import React from 'react';

export default function About(props) {
    const mystyle = { width: 1000, backgroundColor: props.mode === 'dark' ? '#1b2646' : 'white', color: props.mode === 'dark' ? 'white' : '#042743' }

    return (
        <>
            <div className="container my-2 text-center" style={{ color: props.mode === 'dark' ? 'white' : '#042743' }}>
                <h1>About Us</h1>
                <p>In this page we describe a bit of the history, motivations and features behind TextUtils.</p>
            </div>
            <div className="container" style={{ color: props.mode === 'dark' ? 'white' : '#042743' }}>
                <h2>Our features</h2>
                <p>You can find below the features available in TextUtils:</p>

                <div className="container">
                    <div className="card mx-auto my-1" style={mystyle}>
                        <div className="card-body">
                            <h5 className="card-title">Convert to Uppercase</h5>
                            <h6 className="card-subtitle mb-2 text-muted">Converters</h6>
                            <p className="card-text">The online text converter can be used to quickly transform text small letter to capital letters.</p>
                        </div>
                    </div>
                    <div className="card mx-auto my-1" style={mystyle}>
                        <div className="card-body">
                            <h5 className="card-title">Convert to Lowercase</h5>
                            <h6 className="card-subtitle mb-2 text-muted">Converters</h6>
                            <p className="card-text">The online text converter can be used to quickly transform text  capital letters to small letter.</p>
                        </div>
                    </div>
                    <div className="card mx-auto my-1" style={mystyle}>
                        <div className="card-body">
                            <h5 className="card-title">Copy Text after convert</h5>
                            <h6 className="card-subtitle mb-2 text-muted" >Converters</h6>
                            <p className="card-text">This is provide the feature to copy text for contering.</p>
                        </div>
                    </div>
                </div>

            </div>
            <footer className={`text-center text-lg-start footer-${props.mode} bg-${props.mode} text-${props.mode === 'light' ? 'dark' : 'light'}`}>
                <div className="text-center p-3">
                    &copy; 2022 Copyright:
                    <a className="fw-bold" href="/">TextUtils.com</a>
                </div>
            </footer>
        </>
    );
}